import { createSelector } from 'reselect'

const getUserData = state => state.user.data

export default createSelector(
	[ getUserData ],
	userData => userData.school_uid || ''
)
